import { FC } from 'react'
import { Text } from 'yolda-web-ui'
import Icon from '../Icon'
import { Label } from './PackageLabel.style'
import { getLtlIcon } from '../../../utils/helpers'
import { useTranslation } from 'react-i18next'

interface PackageLabelProps {
  height?: number
  length?: number
  number?: number
  text?: string
  type: string
  isPalletExchange?: boolean
  variant?: 'default' | 'alternative'
  weight?: number
  width?: number
  isMixedPackages?: boolean
}

const PackageLabel: FC<PackageLabelProps> = ({
  height,
  length,
  number,
  isPalletExchange,
  text,
  type,
  variant,
  weight,
  width,
  isMixedPackages,
}) => {
  const { t } = useTranslation()

  const variants = {
    default: (
      <>
        <img src={getLtlIcon(type)} />
        <Text>{number}</Text>
        <Text>{text}</Text>
        {isPalletExchange && (
          <Text fontSize="small" fontWeight="medium">
            {' '}
            | {t('PalletExchange.Title')}
          </Text>
        )}
      </>
    ),

    alternative: (
      <>
        <div>
          <img src={getLtlIcon(type)} />
        </div>
        <div>
          <Text fontWeight="medium" fontSize="normal">
            {text}
          </Text>
          {!isMixedPackages && (
            <Text fontSize="small">
              {[width, height, length, weight]?.every(item => !!item)
                ? `${width} x ${length} x ${height}, ${weight}kg`
                : '-'}{' '}
            </Text>
          )}
        </div>
        {!isMixedPackages && <Text fontWeight="medium">{number ? `x${number}` : '-'}</Text>}
      </>
    ),
  }

  return <Label variant={variant}>{variants[variant || 'default']}</Label>
}

export default PackageLabel
